import BigNumber from 'bignumber.js';
import { useState } from 'react';

export const useInputAmount = (value = '0.1', allowEmpty = true) => {
  const [inputAmount, setInputAmount] = useState(value);

  const onChangeInputAmount = (e: React.ChangeEvent<HTMLInputElement>, decimal = 4) => {
    const value = e.target.value;

    if (!value) {
      setInputAmount('');
      return;
    }

    // 只允许数字和小数点，且小数点只能出现一次
    if (!/^\d*\.?\d*$/.test(value)) {
      return;
    }

    // 处理小数点后面的位数
    const parts = value.split('.');
    if (parts.length > 1 && parts[1].length > decimal) {
      setInputAmount(`${parts[0]}.${parts[1].slice(0, decimal)}`);
      return;
    }

    // 处理前导零
    if (value.length > 1 && value.startsWith('0') && !value.startsWith('0.')) {
      setInputAmount(value.slice(1));
      return;
    }
    setInputAmount(value);
  };

  const onBlurInputAmount = () => {
    allowEmpty
      ? setInputAmount(BigNumber(inputAmount || 0).toString(10))
      : setInputAmount(inputAmount == '' || inputAmount == '0' ? '0.1' : BigNumber(inputAmount || 0).toString(10));
  };

  return {
    inputAmount,
    setInputAmount,
    onChangeInputAmount,
    onBlurInputAmount,
  };
};
